import React from 'react';

import { Message, Table } from 'semantic-ui-react';

import PropTypes from 'prop-types';

import CurrencyText from './CurrencyText';
import IconButton from './IconButton';

import { ACCOMMODATION_TYPES } from '../js/lists';

class AccommodationSummarySegment extends React.Component {

  handleIconClick = (entry) => {
    this.download(entry);
  }

  download = async (entry) => {
    const downloadUrl = await entry.downloadUrl();

    if (downloadUrl) {
      window.open(downloadUrl);
    }
  }

  render = () => {
    return (
      (() => {
        if (this.props.accommodation.length === 0) {
          return <Message info compact size='tiny'>No accommodation expenses</Message>;
        }

        let total = 0;
        let accommodations = this.props.accommodation.map(a => {
          let accommodation = { ...a };
          accommodation.displayType = ACCOMMODATION_TYPES[accommodation.type];
          accommodation.gst = accommodation.amount*this.props.settings.gst;
          accommodation.total = accommodation.rate+accommodation.amount+accommodation.gst;
          total = total+accommodation.total;

          accommodation.files = accommodation.files.map(f => {
            let file = { ...f };
  
            let size = file.size;
            let unit = 'B';
            if (size > 1024) {
              size /= 1024;
              unit = 'KB';
            }
            if (size > 1024) {
              size /= 1024;
              unit = 'MB';
            }
            if (size > 1024) {
              size /= 1024;
              unit = 'GB';
            }
  
            file.displaySize = parseFloat(size.toFixed(1));
            file.unit = unit;
            file.displayName = file.name;
  
            return file;
          });
          total = total + this.props.hoteltax;

          return accommodation;
        });

        const position = { 'vertical-align': 'top', 'text-align': 'left' };

        return <Table collapsing basic='very'>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Type</Table.HeaderCell>
              <Table.HeaderCell>Nights</Table.HeaderCell>
              <Table.HeaderCell>Rate</Table.HeaderCell>
              <Table.HeaderCell>Amount</Table.HeaderCell>
              <Table.HeaderCell>GST</Table.HeaderCell>
              <Table.HeaderCell>Hotel Tax</Table.HeaderCell>
              <Table.HeaderCell>Total</Table.HeaderCell>
              <Table.HeaderCell>Files</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body style={ position }>
            { accommodations.map((accommodation, index) => (
              <Table.Row key={ index } id={ `accommodation_${ accommodation.timestamp }`}>
                <Table.Cell>{ accommodation.displayType }</Table.Cell>
                <Table.Cell>{ accommodation.numberofnights }</Table.Cell>
                <Table.Cell><CurrencyText style={ {'text-align': 'left'} } value={ accommodation.rate }/></Table.Cell>
                <Table.Cell><CurrencyText style={ {'text-align': 'left'} } value={ accommodation.amount }/></Table.Cell>
                <Table.Cell>-</Table.Cell>
                <Table.Cell>-</Table.Cell>
                <Table.Cell>-</Table.Cell>
                <Table.Cell>
                  { accommodation.files.map((file, index) => (
                    <span>{ file.displayName+'\t'+file.displaySize+' '+file.unit+'\t' }<IconButton name='arrow down' color='black' size='small' bordered onClick={ this.handleIconClick.bind(this, file) }/><br/></span>
                  ))}
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
          <Table.Footer>
            <Table.Row>
              <Table.Cell>Total:</Table.Cell>
              <Table.Cell></Table.Cell>
              <Table.Cell></Table.Cell>
              <Table.Cell></Table.Cell>
              <Table.Cell><CurrencyText style={ {'text-align': 'left'} } value={ this.props.gst }/></Table.Cell>
              <Table.Cell><CurrencyText style={ {'text-align': 'left'} } value={ this.props.hoteltax }/></Table.Cell>
              <Table.Cell><CurrencyText style={ {'text-align': 'left'} } value={ this.props.totalaftertax }/></Table.Cell>
              <Table.Cell></Table.Cell>
            </Table.Row>
          </Table.Footer>
        </Table>;
      })()
    );
  }
};

AccommodationSummarySegment.propTypes = {
  accommodation: PropTypes.array.isRequired,
  gst: PropTypes.number,
  hoteltax: PropTypes.number,
};

export default AccommodationSummarySegment;
